import Vue from 'vue';
import { Component, Watch } from 'vue-property-decorator';
import { CustomerProfile, FormType } from '@/models';
import { isLoyaltyEnabled } from '@/helpers/country';
import { AccountManagementEvent } from '@/services/analytics/events';
import { LoginCompleteEvent } from '@/services/analytics/events/login-complete-event';

@Component({
  name: 'CmgSignInModal',
})
export default class CmgSignInModal extends Vue {
  currentCountry = this.$appStore.state.ui.countryProfile.countryCode;
  isCreateAccount = false;
  showForm = true; // a flag to toggle animation when swapping country

  get visible(): boolean {
    return this.$appStore.state.ui.modals.signIn.visible;
  }

  get modalImageSrc(): string {
    let src = '';

    if (isLoyaltyEnabled(this.currentCountry)) {
      switch (this.formType) {
        case FormType.CreateAccount: src = this.$appStore.state.cms.createAccountForm?.imageUrl || this.$appStore.state.cms.images.logos.medallionReward.default;
          break;
        case FormType.SignIn: src = this.$appStore.state.cms.signInContentFragment?.imageUrl || this.$appStore.state.cms.images.logos.medallionReward.default;
          break;
        default: src = this.$appStore.state.cms.signInContentFragment?.imageUrl || this.$appStore.state.cms.images.logos.medallionReward.default;
          break;
      }

    } else {
      src = this.$appStore.state.cms.signInContentFragment?.imageUrl || this.$appStore.state.cms.images.logos.medallion.default;
      this.isCreateAccount = false;
    }

    return src;
  }

  get countryProfileChange(): string {
    return this.$appStore.state.ui.countryProfile.countryCode;
  }

  get countryCode(): string {
    return this.currentCountry;
  }

  get modalTitle(): string {
    switch (this.formType) {
      case FormType.CreateAccount:
        return this.isVerifyingMobileNumber ? 'verify your phone number' : this.$appStore.state.cms.createAccountForm?.heading || 'create an account';
      case FormType.GroupOrderSignIn:
        return 'sign in to create a group order';
      case FormType.PasswordResetRequest:
        return 'forgot password';
      default:
        return this.$appStore.state.cms.signInContentFragment?.heading || 'sign in';
    }
  }

  get args() {
    return this.$appStore.state.ui.modals.signIn.args;
  }

  get formType(): FormType {
    return (this.args && this.args.type) || FormType.SignIn;
  }

  get customer(): CustomerProfile | null {
    return this.$appStore.state.customer.profile;
  }

  // For deciding which animation to use.
  get slideFadeType(): string {
    switch (this.formType) {
      case FormType.CreateAccount:
        return 'slide-fade-create-account';
      default:
        return 'slide-fade-sign-in';
    }
  }

  get isVerifyingMobileNumber(): boolean {
    return this.$appStore.state.ui.showVerifyMobileNumber;
  }

  @Watch('countryProfileChange', { immediate: true })
  async countryProfileChanged(country: string) {
    this.currentCountry = country;
  }

  @Watch('visible', { immediate: true })
  async visibleChanged(newVisible: boolean) {
    if (newVisible) {
      Vue.nextTick(() => {
        (document.getElementsByClassName('sign-in-model-header')[0] as HTMLElement).focus();
      });
    }
  }

  async onSignIn() {
    this.$services.sustainability.getHistorySustainabilityMetrics();

    if (this.args && this.args.route) {
      this.$router.push({ name: this.args.route });
    }

    this.$services.analytics.send(new AccountManagementEvent('logins'));
    this.$services.analytics.send(new LoginCompleteEvent());
    this.$services.adobeTarget.sendAdobeTargetExperienceRequest(this.$route.name); 
    
    this.onClose();
  }

  onClose() {
    if (this.isVerifyingMobileNumber) {
      this.$services.ui.setModalVisibility('exitMobileVerificationModal', true);
    } else {
      if (this.args && this.args.onClose) {
        this.args.onClose();
      }
      this.$services.ui.setModalVisibility('signIn', false);
    }
  }

  setCurrentCountry(country: string) {
    this.currentCountry = country;
    this.isCreateAccount = true;

    this.showForm = false;
    setTimeout(() => (this.showForm = true), 350);
  }
}
